module.exports = __webpack_public_path__ + "img/diagnosis-3.d4da9a32.png";